import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7136338e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-column" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "card-header-title"
}

import { computed, onBeforeMount } from "vue"
import { useStore } from "vuex"

import useDetailPage from "./useDetailPage"
import useRouteParams from "@/composables/useRouteParams"
import { useBreakpoints } from "@/helpers"
import { usePartCollectionsData } from "@/composables/collections/usePartCollectionsData"
import i18n from "@/locales"

import InfoWrapper from "@/components/library/content/info/InfoWrapper.vue"
import InfoTags from "@/components/library/content/info/tags/InfoTags.vue"
import WhereUsed from "@/components/library/content/whereused/WhereUsed.vue"
import Related from "@/components/library/content/related/Related.vue"
import Comments from "@/components/library/content/comments/Comments.vue"
import Suggestions from "@/components/library/content/suggestions/Suggestions.vue"
import Attachments from "@/components/library/content/attachments/Attachments.vue"
import PartCollectionsWrapper from "../collections/PartCollectionsWrapper.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnLayout',
  props: {
  columnInfo: {
    type: Object,
    required: true
  }
},
  setup(__props) {



const store = useStore()
const { width } = useBreakpoints()
const { id } = useRouteParams()
const {
  content,
  showComments,
  showSuggestions,
  showInfoTags,
  showWhereUsed,
  showRelated,
  showAttachments,
  canViewAttachments,
  showPartCollections,
  hasPartCollections
} = useDetailPage()
const { hasAnExpandedCollection } = usePartCollectionsData(
  id.value,
  (part: any) => part
)

const isWidget = computed(() => store.getters['widgets/isWidget'])

const isMobileView = computed(() => width.value <= 768)

function castIdToNumber (id: string) {
  return parseInt(id)
}

function componentAvailable (componentName: String): boolean {
  switch (componentName) {
    case 'InfoWrapper':
      return true
    case 'InfoTags':
      return showInfoTags.value
    case 'WhereUsed':
      return showWhereUsed.value
    case 'Related':
      return showRelated.value
    case 'Attachments':
      return showAttachments.value
    case 'Comments':
      return showComments.value
    case 'Suggestions':
      return showSuggestions.value
    case 'PartCollections':
      return showPartCollections.value
    default:
      return false
  }
}

function componentHeight (componentName: String): string {
  if (componentName === 'WhereUsed' && !isMobileView.value) { return '90vh' }
  else { return '60vh'}
}

const componentMap = new Map<string, any>([
  ['InfoWrapper', InfoWrapper],
  ['InfoTags', InfoTags],
  ['WhereUsed', WhereUsed],
  ['Related', Related],
  ['Attachments', Attachments],
  ['Comments', Comments],
  ['Suggestions', Suggestions],
  ['PartCollections', PartCollectionsWrapper]
])

const titleMap = new Map<string, any>([
  ['InfoTags', i18n.global.tc('detail', 2)],
  ['WhereUsed', i18n.global.t('whereUsed')],
  ['Related', i18n.global.t('related')],
  ['Attachments', i18n.global.tc('attachment', 2)],
  ['Comments', i18n.global.tc('comment', 2)],
  ['Suggestions', i18n.global.tc('suggestion', 2)],
  ['PartCollections', i18n.global.tc('partCollection', 2)]
])

onBeforeMount(async () => {
  if (canViewAttachments.value || isWidget.value) {
    await store.dispatch("content/getAttachments")
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columnInfo, (value, key) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
        (componentAvailable(value))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: value,
              class: _normalizeClass(["card detail-card column-item", {
              'where-used-card': value === 'WhereUsed',
              'part-collections-outer': value === 'PartCollections' && _unref(hasPartCollections),
              'expanded-part-collections-outer': value === 'PartCollections' && _unref(hasAnExpandedCollection),
              'part-collections-outer--empty': value === 'PartCollections' && !_unref(hasPartCollections)
            }])
            }, [
              (_unref(titleMap).has(value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t(_unref(titleMap).get(value))), 1))
                : _createCommentVNode("", true),
              (_unref(componentMap).has(value))
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentMap).get(value)), {
                    key: 1,
                    id: castIdToNumber(_unref(content).id),
                    content: _unref(content),
                    type: _unref(content).type,
                    showTags: false,
                    height: componentHeight(value)
                  }, null, 8, ["id", "content", "type", "height"]))
                : _createCommentVNode("", true)
            ], 10, _hoisted_2))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})